import { GetResponseType } from '../types';
import useApi from '../hooks/useApi';
import { AUTH_TOKEN, WITH_AUTH } from 'app/constants';
import { decodeJWT } from 'app/components/utils/utils';

export interface InviteUserRequestType {
  full_name: string;
  email: string;
  email_notification: boolean;
  access_list: AccessItem[];
}

export interface InviteUserResponseType {
  id: string;
  access_list: AccessItem[];
  organization_id: string;
  role: UserRole;
  full_name: string;
  email: string;
  is_email_confirmed: boolean;
  email_notification: boolean;
  is_active: boolean;
  status_description: UserStatus;
  created_at: string;
  updated_at: string;
}

export interface GetInvitedUsersResponseType {
  item_count: number;
  page_count: number;
  data: InviteUserResponseType[] | null;
}

export interface UpdateUserRequestType {
  is_active: boolean;
  full_name: string;
  email_notification: boolean;
  access_list: AccessItem[];
}

export enum UserStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE'
}

export enum AccessItem {
  FullAccess = 'Full Access'
}

export enum UserRole {
  Owner = 'owner'
}

export const inviteUser = async (
  payload: InviteUserRequestType
): Promise<GetResponseType<InviteUserResponseType>> => {
  const { data, error, loading, httpCode } = await useApi(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/users`,
    'POST',
    payload,
    {},
    WITH_AUTH
  );
  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const getInvitedUsers = async (
  page?: number,
  pageSize?: number
): Promise<GetResponseType<GetInvitedUsersResponseType>> => {
  const getPageOption = () => {
    if (!page && !pageSize) return '';
    if (page && pageSize) return `?page=${page}&pageSize=${pageSize}`;
    if (!page && pageSize) return `?pageSize=${pageSize}`;
    if (page && !pageSize) return `?page=${page}`;
  };

  const { data, error, loading, httpCode } = await useApi(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/users${getPageOption()}`,
    'GET',
    null,
    {},
    WITH_AUTH
  );
  return {
    data,
    httpCode,
    error,
    loading
  };
};

export const updateUser = async (
  userId: string,
  payload: UpdateUserRequestType
): Promise<GetResponseType<InviteUserResponseType>> => {
  const { data, error, loading, httpCode } = await useApi(
    `${process.env.REACT_APP_TRAFFIC_EXCHANGE_CONSOLE_API_URL}/users/${userId}`,
    'PUT',
    payload,
    {},
    WITH_AUTH
  );
  return {
    data,
    httpCode,
    error,
    loading
  };
};
